import React from "react";

import { Title } from "@patternfly/react-core";

import SchoolMobileBackButton from "./SchoolMobileBackButton";

import "./SchoolMobileViewHeader.css";

const SchoolMobileViewHeader = ({ title }) => {
  return (
    <header className="school-mobile-view-header">

      <SchoolMobileBackButton />

      <Title headingLevel="h2">
        {title}
      </Title>

    </header>
  );
};

export default SchoolMobileViewHeader;